import { getEnvironment } from "@/utils";

const applyAdobeTargetPrehiding = () => {
  window.isPagePrehiding = true;

  const headElement = document.getElementsByTagName("head")[0];
  if (headElement && !document.getElementById("at-body-style")) {
    const styleElement = document.createElement("style");
    styleElement.id = "at-body-style";
    styleElement.innerHTML = "body {opacity: 0 !important}";
    headElement.appendChild(styleElement);
  }

  setTimeout(() => {
    const currentHeadElement = document.getElementsByTagName("head")[0];
    const styleElement = document.getElementById("at-body-style");

    if (currentHeadElement && styleElement) {
      currentHeadElement.removeChild(styleElement);
    }
  }, 3000);
};

/**
 * Plugin helper para determinar el entorno por URL e inyectar la
 * libreria de Launch apropiada ya que por entorno es imposible
 * controlarlo por Jenkins
 */
const AdobeLaunch = {
  install(Vue) {
    const environment = getEnvironment();

    applyAdobeTargetPrehiding();

    const scriptElement = document.createElement("script");
    scriptElement.src = environment.adobeLaunch;
    scriptElement.async = true;
    scriptElement.defer = true;

    document.head.appendChild(scriptElement);
    Vue.$log.info("AdobeLaunch inyectada", environment.description);
  }
};

export default AdobeLaunch;
